module.exports = __webpack_public_path__ + "img/22.1b1413f2.png";